// let _confirmDialog = null;

class AppMem {

}

module.exports = AppMem;



// WEBPACK FOOTER //
// ./src/common/AppMem.js